import { Helpers } from '../../helpers';
import { IPrioritizationCategory } from '../../interfaces/iprioritization-category';
import { DataType } from '../data-type';
import { PrioritizationCriterion } from '../prioritization-criterion';

export class PrioritizationCategoryBase {
  PrioritizationCategoryId: number;
  Name: string;
  DataTypeId: number | null;
  LookupTableName: string | null;
  MinimumValue: number | null;
  MaximumValue: number | null;
  StepValue: number | null;
  ValueColumnName: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  PrioritizationCriteria_PrioritizationCategory?: Array<PrioritizationCriterion> | null;
  DataType?: DataType;

  constructor(item?: IPrioritizationCategory) {
    if (item) {

      this.PrioritizationCategoryId = item.PrioritizationCategoryId;
      this.Name = item.Name;
      this.DataTypeId = item.DataTypeId;
      this.LookupTableName = item.LookupTableName;
      this.MinimumValue = item.MinimumValue;
      this.MaximumValue = item.MaximumValue;
      this.StepValue = item.StepValue;
      this.ValueColumnName = item.ValueColumnName;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.PrioritizationCriteria_PrioritizationCategory = Helpers.createClassArray(PrioritizationCriterion, item.PrioritizationCriteria_PrioritizationCategory);
      this.DataType = new DataType(item.DataType);
    }
  }
}